import { ActionSaveType } from 'src/editor/shared/types/automation-rules/actions-types'
import { ResourceBaseNumberOptionInterface } from 'src/editor/shared/types/resources-interface'
import { getAutomationRuleActionIdAndLabel } from 'src/editor/shared/settings/automation-rules-settings/utils/get-automation-rule-action-id-and-label'

export const getResourceSelectedOption = (
  action: ActionSaveType,
  userResources: ResourceBaseNumberOptionInterface[],
  resourceId?: number,
) => {
  if (resourceId) {
    return getOptionFromResources(userResources, resourceId) as {
      value: number
      label: string
    }
  }
  const { id, label } = getAutomationRuleActionIdAndLabel(action) || {}

  return id
    ? ({
        value: id,
        label: label,
      } as { value: number; label: string })
    : null
}

function getOptionFromResources(
  userResources: ResourceBaseNumberOptionInterface[],
  resourceId: number,
) {
  const resourceOption = userResources.find(item => item.value === resourceId)

  return resourceOption
    ? {
        value: resourceOption.value,
        label: resourceOption.label,
      }
    : undefined
}
